import { render } from "./opAddress.vue?vue&type=template&id=5c1cf080&ts=true"
import script from "./opAddress.vue?vue&type=script&lang=ts"
export * from "./opAddress.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__